import { FC, ReactNode, useMemo } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import useIsWebview from '@app.modules/hooks/useIsWebview'
import { getWebviewHref } from '@app.modules/util'
import SearchMobileHeader from '../component/SearchMobileHeader'
import HotKeywordList from './HotKeywordBoxList'
import ChannelSearchAllMobile from './menus/ChannelSearchAll/ChannelSearchAllMobile'
import ChannelSearchChannelListMobile from './menus/ChannelSearchChannel/ChannelSearchChannelMobile'
import ChannelSearchNewsListMobile from './menus/ChannelSearchNews/ChannelSearchNewsListMobile'

type TMenu = 'all' | 'channel' | 'news'

const ScreenChannelSearchMobile: FC = () => {
  const router = useRouter()
  const isWebview = useIsWebview()
  const query = useMemo(() => {
    return `${router.query.q || ``}`
  }, [router.query])

  const tabToMenu: {
    [key in TMenu]: ReactNode
  } = {
    all: <ChannelSearchAllMobile />,
    news: <ChannelSearchNewsListMobile />,
    channel: <ChannelSearchChannelListMobile />,
  }
  const handleClose = () => {
    if (router.query.back) router.push(`${router.query.back}`)
    else router.push(getWebviewHref('/channel', isWebview))
  }

  const selectedTab = useMemo(
    () => `${router.query.tab ? router.query.tab : 'all'}`,
    [router.query],
  ) as TMenu

  return (
    <StyledWrapper data-webview={isWebview}>
      <SearchMobileHeader title="채널 검색" onClose={handleClose} />
      {query === '' && <HotKeywordList />}
      {query !== '' && (
        <>
          <div className="menu-list">
            <Link
              href={{
                query: {
                  ...router.query,
                  tab: 'all',
                },
              }}
            >
              <a className="menu" data-active={selectedTab === 'all'}>
                전체
              </a>
            </Link>
            <Link
              href={{
                query: {
                  ...router.query,
                  tab: 'news',
                },
              }}
            >
              <a className="menu" data-active={selectedTab === 'news'}>
                소식
              </a>
            </Link>
            <Link
              href={{
                query: {
                  ...router.query,
                  tab: 'channel',
                },
              }}
            >
              <a className="menu" data-active={selectedTab === 'channel'}>
                채널
              </a>
            </Link>
          </div>
          <div className="tab-content">{tabToMenu[selectedTab]}</div>
        </>
      )}
    </StyledWrapper>
  )
}

export default ScreenChannelSearchMobile

const StyledWrapper = styled.div`
  height: 100vh;
  padding-top: 58px;
  background-color: #fafafa;
  .menu-list {
    position: fixed;
    width: 100%;
    top: 108px;
    z-index: 2;
    height: 50px;
    border-bottom: 1px solid #e8e8e8;
    background-color: #fafafa;
    display: flex;
    align-items: stretch;
    padding: 0 20px;
    gap: 20px;
    .menu {
      cursor: pointer;
      padding: 0;
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #999;
      :hover {
        background-color: transparent;
      }
      &[data-active='true'] {
        color: #333;
        font-weight: bold;
      }
    }
  }
  &[data-webview='true'] {
    padding-top: 58px;
    .menu-list {
      top: 58px;
    }
  }
  .content-header {
    height: 50px;
    padding: 20px 20px 13px;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #999;
    .more-btn {
      color: #999;
      display: flex;
      align-items: center;
      gap: 5px;
      svg {
        width: 12px;
        height: 12px;
      }
    }
  }
  .channel-card-empty {
    background-color: white;
    height: 170px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    .empty-title {
      font-size: 16px;
      margin-bottom: 5px;
      font-weight: 500;
      span {
        color: #01a0ff;
      }
    }
    .empty-subtitle {
      font-size: 12px;
      color: #999;
    }
  }
  .tab-content {
    padding-top: 50px;
  }
`
